import { coreApi, createVenueSpecificClient } from '$api'
import { StaffRole } from '$models'
import {
  getActiveCompanySettings,
  singletonQueryClient,
  getCompanyId,
} from '$utils'
import sortBy from 'lodash/sortBy'

/**
 * Get all Staff Role
 * @param includeDeleted - include the deleted staff roles
 * @param venueId - optional venue ID to fetch roles for specific venue
 * @returns Promise<StaffRole[]>
 */
export const getAll = async (
  includeDeleted: boolean = true,
  venueId?: string
): Promise<StaffRole[]> => {
  const { hasTimePermission } = getActiveCompanySettings()

  if (!hasTimePermission) return []

  const client = venueId ? createVenueSpecificClient(venueId) : coreApi
  const companyId = venueId || getCompanyId()

  return singletonQueryClient.fetchQuery({
    queryKey: ['getAllStaffRoles', companyId, includeDeleted],
    queryFn: async () => {
      const roles = await client.getStaffRoles(includeDeleted)
      return sortBy<StaffRole>(roles, 'name')
    },
  })
}
